export default "__VITE_ASSET__ByF2e3vt__"